import { onMounted, onUnmounted, ref } from 'vue'

export const isBrowser = typeof window !== 'undefined'

function getInitialState(query, defaultState) {
  if (defaultState !== undefined) {
    return defaultState
  }

  if (isBrowser) {
    return window.matchMedia(query).matches
  }

  return false
}

export function useMedia(query, defaultState) {
  const state = ref(getInitialState(query, defaultState))

  onMounted(() => {
    let mounted = true
    const mql = window.matchMedia(query)

    function onChange() {
      if (mounted) {
        state.value = !!mql.matches
      }
    }

    mql.addEventListener('change', onChange)
    state.value = mql.matches

    onUnmounted(() => {
      mounted = false
      mql.removeEventListener('change', onChange)
    })
  })

  return state
}
